import React from 'react';
import { BannerConfig } from '../types';
import drinksDesktop from '../assets/hero/drinks-desktop.jpg'; // 👈 import forced image

interface BannerProps {
  config: BannerConfig;
}

const Banner: React.FC<BannerProps> = ({ config }) => {
  const {
    logo,
    logoAlt = 'Site Logo',
    bannerImage = 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    bannerAlt = 'Banner Image',
    title = 'Never miss another moment.',
    subtitle = 'Find your Vybe. Join your tribe',
    textColor = 'text-white',
    overlayOpacity = 60,
    customContent
  } = config;

  const overlayAlpha = Math.min(100, Math.max(0, overlayOpacity)) / 100;

  return (
    <section
      className="
        relative w-full overflow-hidden rounded-b-3xl
        h-[220px] sm:h-[280px] md:h-[360px] lg:h-[420px]
      "
    >
      {/* 👇 Force mobile to use drinks-desktop.jpg */}
      <picture className="absolute inset-0 block z-0">
        <source media="(min-width: 769px)" srcSet={bannerImage} />
        <img
          src={drinksDesktop}
          alt={bannerAlt}
          className="absolute inset-0 w-full h-full object-cover z-0"
          loading="eager"
          fetchpriority="high"
          decoding="async"
        />
      </picture>

      {/* Overlay (behind content) */}
      <div
        className="absolute inset-0 z-[1]"
        style={{
          background:
            'linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.35) 60%, rgba(0,0,0,0.35) 100%)',
          opacity: overlayAlpha,
        }}
      />

      {/* CONTENT */}
      {customContent ? (
        <div className="relative z-10 h-full flex items-center justify-center px-4">
          {customContent}
        </div>
      ) : (
        <div className="relative z-10 h-full container mx-auto px-3 sm:px-4 flex flex-col justify-center items-start">
          {logo && (
            <div className="mb-3 sm:mb-6">
              <img
                src={logo}
                alt={logoAlt}
                className="h-10 sm:h-16 md:h-20 w-auto"
                decoding="async"
              />
            </div>
          )}

          <div
            className={`max-w-xs sm:max-w-md md:max-w-2xl ${textColor} bg-black/30 p-4 sm:p-6 rounded-3xl backdrop-blur-sm border border-white/10`}
          >
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-sora font-semibold mb-2 sm:mb-4">
              {title}
            </h1>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/90">
              {subtitle}
            </p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Banner;
